import { InjectionToken, Provider, Type } from "@angular/core";
import { CampaignType, SDStrategy, SPStrategy } from "@front/m19-api-client";
import { provideCampaignType, StrategyService } from "@front/m19-injection-token";
import { SdStrategyService, SpStrategyService } from "@front/m19-services";
import {
  BulkUploadContextService,
  BulkUploadHandler,
  SupportedBulkUploadEntityModel,
} from "./bulk-upload-context.service";

export const BULK_UPLOAD_HANDLER = new InjectionToken<BulkUploadHandler<SupportedBulkUploadEntityModel>>(
  "BULK_UPLOAD_HANDLER",
);

export function provideBulkUpload<T>(handler: Type<BulkUploadHandler<T>>): Provider[] {
  return [{ provide: BULK_UPLOAD_HANDLER, useClass: handler }, BulkUploadContextService];
}

export function provideStrategyBulkUpload<T extends SPStrategy | SDStrategy>(
  campaignType: CampaignType.SP | CampaignType.SD,
  handler: Type<BulkUploadHandler<T>>,
): Provider[] {
  const strategyServiceClass = campaignType === CampaignType.SP ? SpStrategyService : SdStrategyService;
  return [
    provideCampaignType(campaignType),
    { provide: StrategyService, useExisting: strategyServiceClass },
    ...provideBulkUpload(handler),
  ];
}
